import React from "react";
import Card from "./Card";
import BeadsCurtain from "./beads-curtain.gif"; // Your image path
import Section from "./Section";
function DIYComparison(props) {
  const sections = [
    {
      content: (
        <div className="w-full">
          <ol className="pl-5 space-y-2 text-center text-xl font-bold">
            <li>비즈발 만들기</li>
            <br />
          </ol>
        </div>
      ),
      image: (
        <img
          alt="beads-curtain"
          src={BeadsCurtain}
          className="rounded-lg shadow-lg hover:shadow-xl transition-shadow duration-300"
        />
      ),
      isLeftAligned: false,
    },
    // Add more sections as needed
  ];

  return (
    <Section
      {...props}
      content={sections.map((section, index) => (
        <>
          <Card
            key={index}
            title={section.title}
            content={section.content}
            image={section.image}
            isLeftAligned={section.isLeftAligned}
          />
        </>
      ))}
    />
  );
}

export default DIYComparison;
